<template>
  <el-dialog
    append-to-body
    v-dialogDrag
    :title="`${$t(title)}`"
    class="mid-dialog"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <el-form :model="form" ref="form" class="!ml-0 h-full">
      <el-table :data="form.tableData" stripe border height="100%">
        <el-table-column type="index" width="60" :label="`${$t('序号')}`"></el-table-column>
        <el-table-column prop="chapter" width="100" :label="`${$t('项目序号')}`"></el-table-column>
        <el-table-column :label="`${$t('存在问题')}`">
          <template slot-scope="scope">
            <el-form-item
              label=""
              label-width="0"
              class="mt-20px"
              :prop="`tableData[${scope.$index}].problem`"
              :rules="[
                {
                  required: true,
                  message: `${$t('请填写存在问题')}`,
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="scope.row.problem"
                :placeholder="`${$t('请输入')}`"
                :maxlength="1000"
                show-word-limit
                :autosize="{ minRows: 4 }"
                :disabled="disabled"
                type="textarea"
                class="!w-full"
                @change="changeRow(scope.row)"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="scoringStandard" :label="`${$t('扣分标准')}`"> </el-table-column>
        <el-table-column
          prop="standardScore"
          width="100"
          :label="`${$t('标准分')}`"
        ></el-table-column>
        <el-table-column width="120" :label="`${$t('实际得分')}`">
          <template slot-scope="scope">
            <el-form-item
              label=""
              label-width="0"
              class="mt-20px"
              :prop="`tableData[${scope.$index}].score`"
              :rules="[
                {
                  required: true,
                  message: `${$t('请填写实际得分')}`,
                  trigger: 'blur',
                },
              ]"
            >
              <el-input-number
                v-model="scope.row.score"
                :placeholder="`${$t('请输入')}`"
                :min="0"
                :max="scope.row.standardScore"
                :controls="false"
                :disabled="disabled"
                class="!w-full"
                @change="changeRow(scope.row)"
              ></el-input-number>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="" width="100" :label="`${$t('操作')}`">
          <template slot-scope="scope">
            <el-button @click="deleteRow(scope.$index)" size="mini" :disabled="disabled">{{
              $t('删除')
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div slot="footer" class="text-center" v-if="!disabled">
      <el-button
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="save()"
        :loading="loading"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="closeDialog()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { SafetyEvaluationSolutionApi } from '@wiz-api/safety-evaluation-management'
import { cloneDeep, find } from 'lodash'

const safetyEvaluationSolutionApi = new SafetyEvaluationSolutionApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'view',
    },
    standardName: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        tableData: [],
      },
      changeList: [],
      loading: false,
    }
  },
  computed: {
    title() {
      return `${this.mode === 'view' ? '查看' : '新增'}${this.standardName}问题`
    },
    disabled() {
      return this.mode === 'view'
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.form.tableData = cloneDeep(this.list)
      }
    },
  },
  methods: {
    changeRow(row) {
      console.log(row)
      const item = find(this.changeList, { id: row.id })
      if (!item) {
        this.changeList.push({
          evaluationContent: row.evaluationContent,
          score: row.score,
          problem: row.problem,
          id: row.id,
        })
      } else {
        item.score = row.score
        item.problem = row.problem
      }
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.changeList.length) {
            this.saveChange(0)
          }
        }
      })
    },
    async saveChange(index) {
      if (index === 0) {
        this.loading = true
      }
      const item = this.changeList[index]
      console.log(item)
      await safetyEvaluationSolutionApi.evaluate(this.id, item.id, {
        body: item,
      })
      if (index === this.changeList.length - 1) {
        this.loading = false
        this.$emit('save', this.form.tableData)
        this.closeDialog()
      } else {
        this.saveChange(index + 1)
      }
    },
    closeDialog(done) {
      this.form.tableData = []
      this.loading = false
      this.$refs.form.clearValidate()
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
    deleteRow(index) {
      const row = this.form.tableData[index]
      this.changeRow({
        evaluationContent: row.evaluationContent,
        score: row.score,
        problem: '',
        id: row.id,
      })
      this.form.tableData.splice(index, 1)
    },
  },
}
</script>

<style></style>
